<template>
	<div style="margin-left: 350px; width: calc(100% - 350px)">
		<v-toolbar flat color="white">
			<v-toolbar-title>Contents to upload</v-toolbar-title>
			<v-spacer></v-spacer>
		</v-toolbar>

		<v-data-table
			hide-actions
			:headers="headers"
			:items="contents"
			class="elevation-0"
			v-if="contents.length > 0"
			style="position: absolute; top: 120px; left: 350px; right: 0px; bottom: 0px; overflow: auto"
		>
			<template v-slot:items="props">
				<td>
					<v-icon v-if="props.item.status == ContentOperationStatus.notStarted" color="primary">mdi-circle-outline</v-icon>
					<v-icon v-else-if="props.item.status == ContentOperationStatus.inProgress" color="orange">mdi-progress-clock</v-icon>
					<v-icon v-else-if="props.item.status == ContentOperationStatus.done" color="green">mdi-check-circle</v-icon>
					<v-tooltip bottom v-else-if="props.item.status == ContentOperationStatus.error">
						<template v-slot:activator="{ on }">
							<v-icon color="red" v-on="on">mdi-circle</v-icon>
						</template>
						<span>{{ props.item.error }}</span>
					</v-tooltip>
				</td>
				<td v-if="props.item.filename" class="original-filename" :title="props.item.filename">{{ props.item.filename }}</td>
				<td>
					<input
						class="hw-100"
						:value="props.item.custom_id"
						@blur="v => (props.item.custom_id = v.target.value)"
						:contenteditable="!disabled"
						placeholder="Custom ID"
						:title="props.item.custom_id"
					/>
				</td>
				<td>
					<input
						class="hw-100"
						:value="props.item.custom_revision"
						@blur="v => (props.item.custom_revision = v.target.value)"
						:contenteditable="!disabled"
						placeholder="Custom Revision"
						:title="props.item.custom_revision || 'Custom Revision'"
					/>
				</td>
				<td>
					<input
						class="hw-100"
						:value="props.item.title"
						@blur="v => (props.item.title = v.target.value)"
						:contenteditable="!disabled"
						placeholder="Title"
						:title="props.item.title"
					/>
				</td>
				<td v-if="showObjectiveRaw" class="objective-id">
					<div
						v-if="contentHasObjective(props.item) && props.item.body.contents.instructionalSettings?.objective.$origin"
						:title="props.item.body.contents.instructionalSettings.objective.custom_id"
					>
						{{ props.item.body.contents.instructionalSettings.objective.custom_id }}
					</div>
					<div v-else class="obj-not-found">No content found</div>
				</td>
				<td v-if="props.item.body.attachments.length > 0">
					<v-tooltip bottom>
						<template v-slot:activator="{ on }">
							<v-chip
								v-on="on"
								small
								:color="getAttachmentBadgeColor(props.item.body)"
								text-color="white"
							>
								<v-icon left>mdi-attachment</v-icon>
								{{ props.item.body.attachments.length }}
							</v-chip>
						</template>
						<span>
							This content has {{ props.item.body.attachments.length }} file{{
								props.item.body.attachments.length > 1 ? 's' : ''
							}}
							attached (
							<span v-for="(attachment, index) in props.item.body.attachments">
								{{ attachment.attachment_type }} <span v-if="index + 1 < props.item.body.attachments.length">, </span>
							</span>
							)
						</span>
					</v-tooltip>
				</td>
				<td class="justify-center layout px-0">
					<v-btn
						v-if="!disabled"
						color="red"
						icon
						flat
						@click.stop="
							contents.splice(
								contents.findIndex(e => e == props.item),
								1
							)
						"
					>
						<v-icon>mdi-delete-outline</v-icon>
					</v-btn>
				</td>
			</template>
		</v-data-table>
	</div>
</template>

<script>
import { ContentOperationStatus } from "plant-common/src/models/contentOperationStatus"

export default {
	props: ['contents', 'disabled', 'type'],
	data() {
		return {
			ContentOperationStatus,
			showObjectiveRaw: false,
			headers: [
				{
					text: '',
					value: '',
					sortable: false,
					width: '40px'
				},
				{
					text: 'Custom Id',
					value: 'custom_id',
					sortable: true,
				},
				{
					text: 'Custom Revision',
					value: 'custom_revision',
					sortable: true,
					width: '200px'
				},
				{ text: 'Title', value: 'title', sortable: true, width: '240px' },
			]
		};
	},
	created() {
		this.addFilenameColumnIfNeeded();

		if (!this.contents.length) return;

		this.addObjectiveColumnIfNeeded();
		this.addActionColumnIfNeeded();
	},
	methods: {
		addFilenameColumnIfNeeded() {
			const firstContent = this.contents[0];

			if (!firstContent.filename) return;

			this.headers.splice(1, 0, {
				text: 'Original Filename',
				value: 'filename',
				sortable: true,
				width: '150px'
			});
		},
		addObjectiveColumnIfNeeded() {
			const hasObjective = this.contents.some(content =>
				this.contentHasObjective(content)
			);

			if (!hasObjective) return;

			const titleIndex = this.headers.findIndex(header => header.value === 'title');

			this.headers.splice(titleIndex + 1, 0, {
				text: 'Objective',
				value: '',
				sortable: false,
				width: '200px'
			});

			this.showObjectiveRaw = true;
		},
		addActionColumnIfNeeded() {
			if (this.disabled) return;

			this.headers.push({
				text: '',
				value: '',
				sortable: false,
				width: '30px'
			});
		},
		getAttachmentBadgeColor(body) {
			const attachments = body.attachments;

			if (this.type === 'diagram' && attachments.length < 2) return 'orange';

			return 'blue';
		},
		contentHasObjective(content) {
			const body = content.body;
			const contents = body.contents;
			const instructionalSettings = contents.instructionalSettings;
			const objective = instructionalSettings && instructionalSettings.objective;

			return Boolean(objective);
		}
	}
};
</script>

<style scoped>
td,
td input,
td div {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.hw-100 {
	height: 100%;
	width: 100%;
}
.original-filename {
	max-width: 150px;
	overflow: hidden;
}
.objective-id {
	max-width: 200px;
	overflow: hidden;
}
.obj-not-found {
	width: 100px;
	font-weight: 600;
}
</style>
